import { getAgentType } from '@/utils/check'
import store from '@/store'
import { saveExecuteMenu } from '@/api/common/user'
export default {
  state: {
    path: '',
    name: '',
    fullPath: '',
    agentType: '',
    // path 기반으로 menu 정보를 가져와 반영한다.
    // 이때, ID 값을 셋팅한다. 값이 없을 경우, 화면(프로그램) name 값이 들어간다.
    menuId: '',
    flag: ''
  },
  mutations: {
    SET_LOG_FLAG: (state, flag) => {
      state.flag = flag
    },
    SET_LOG_PATH: (state, path) => {
      state.path = path
    },
    SET_LOG_NAME: (state, name) => {
      state.name = name
    },
    SET_LOG_FULL_PATH: (state, fullPath) => {
      state.fullPath = fullPath
    },
    SET_LOG_AGENT_TYPE: (state, agentType) => {
      state.agentType = agentType
    },
    SET_LOG_MENU: (state, menuObj) => {
      state.menuId = menuObj.menu_id
    }
  },
  actions: {
    SetCurrnetRoute({ commit }, to) {
      // 변경이되는 to 정보를 받아와 정보를 셋팅한다.
      // 차후 이 정보는 사용자 이벤트 로깅 시 사용된다.
      commit('SET_LOG_PATH', to.path)
      commit('SET_LOG_NAME', to.name)
      commit('SET_LOG_FULL_PATH', to.fullPath)
      let currentMenu = _.find(store.state.menu.menus, { href: to.path })
      var tFlag = _.cloneDeep(store.state.tagsView.cachedViews.length)
      if (!currentMenu) {
        currentMenu = {
          menu_id: to.name
        }
      } else {
        const exV = _.find(store.state.tagsView.visitedViews, { path: to.path })
        if (!exV) {
          // saveExecuteMenu(currentMenu.menu_id)
        }
      }
      commit('SET_LOG_MENU', currentMenu)
      commit('SET_LOG_FLAG', tFlag)
    },
    SetAgentType({ commit }, agentType) {
      commit('SET_LOG_AGENT_TYPE', getAgentType())
    }
  }
}
